import React, { useState } from 'react';
//Transition
import { TransitionGroup, CSSTransition } from 'react-transition-group';
//Material-UI
import { TextField, IconButton } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
//Icons
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
//Context
import { useLlamadas } from './LlamadasContext';

export default function Ubicacion() {
    const { tiposUbicacion, sites, areas, ubRepeater, setUbRepeater } = useLlamadas();
    const token = JSON.parse(sessionStorage.getItem('token'))?.token;

    const [selSite, setSelSite] = useState(null);
    const [selArea, setSelArea] = useState(null);
    const [selLinea, setSelLinea] = useState(null);
    const [selCelda, setSelCelda] = useState(null);
    const [areasBySite, setAreasBySite] = useState([]);
    const [lineasByArea, setLineasByArea] = useState([]);
    const [celdasByLinea, setCeldasByLinea] = useState([]);

    const getTpNombre = (codigo) =>
        tiposUbicacion.find(t => t.codigo === codigo)?.nombre ?? '';

    const handleSiteChange = async (e) => {
        const val = e.target.value;
        const site = val ? sites.find(s => s.codigo.toString() === val) ?? null : null;
        setSelSite(site);
        setSelArea(null); setSelLinea(null); setSelCelda(null);
        setAreasBySite([]); setLineasByArea([]); setCeldasByLinea([]);
        if (!site) return;
        try {
            const res = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/areas?site=${site.codigo}`,
                { headers: { authorization: `Bearer ${token}`, Accept: 'application/json' } }
            );
            if (res.ok) {
                const data = await res.json();
                data.forEach(item => { item.codigo = item.area1; });
                setAreasBySite(data.length > 0 ? data : areas);
            } else {
                setAreasBySite(areas);
            }
        } catch {
            setAreasBySite(areas);
        }
    };

    const handleAreaChange = async (e) => {
        const val = e.target.value;
        const displayAreas = areasBySite.length > 0 ? areasBySite : areas;
        const area = val ? displayAreas.find(a => a.codigo.toString() === val) ?? null : null;
        setSelArea(area);
        setSelLinea(null); setSelCelda(null);
        setLineasByArea([]); setCeldasByLinea([]);
        if (!area) return;
        try {
            const res = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/lineas?area=${area.codigo}`,
                { headers: { authorization: `Bearer ${token}`, Accept: 'application/json' } }
            );
            if (res.ok) {
                const data = await res.json();
                data.forEach(item => { item.codigo = item.id; });
                setLineasByArea(data);
            }
        } catch { }
    };

    const handleLineaChange = async (e) => {
        const val = e.target.value;
        const linea = val ? lineasByArea.find(l => l.codigo.toString() === val) ?? null : null;
        setSelLinea(linea);
        setSelCelda(null); setCeldasByLinea([]);
        if (!linea) return;
        try {
            const res = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT}/CeldaPorLinea/CeldaPorLinea?linea=${linea.codigo}`,
                { headers: { authorization: `Bearer ${token}`, Accept: 'application/json' } }
            );
            if (res.ok) {
                const raw = await res.json();
                const cells = raw
                    .flatMap(l => l.celdas || [])
                    .filter(c => c.orden !== 0)
                    .map(c => ({ codigo: c.celda, nombre: c.nombreCelda }));
                setCeldasByLinea(cells);
            }
        } catch { }
    };

    const handleCeldaChange = (e) => {
        const val = e.target.value;
        const celda = val ? celdasByLinea.find(c => c.codigo.toString() === val) ?? null : null;
        setSelCelda(celda);
    };

    const newUb = (event) => {
        event.preventDefault();
        let tipoUbicacion, ubicacion, tpUbNombre, ubNombre;
        if (selCelda) {
            tipoUbicacion = 4; ubicacion = selCelda.codigo;
            tpUbNombre = getTpNombre(4); ubNombre = selCelda.nombre;
        } else if (selLinea) {
            tipoUbicacion = 3; ubicacion = selLinea.codigo;
            tpUbNombre = getTpNombre(3); ubNombre = selLinea.nombre;
        } else if (selArea) {
            tipoUbicacion = 2; ubicacion = selArea.codigo;
            tpUbNombre = getTpNombre(2); ubNombre = selArea.nombre;
        } else if (selSite) {
            tipoUbicacion = 1; ubicacion = selSite.codigo;
            tpUbNombre = getTpNombre(1); ubNombre = selSite.nombre;
        } else {
            tipoUbicacion = 0; ubicacion = null;
            tpUbNombre = getTpNombre(0); ubNombre = null;
        }
        setUbRepeater([...ubRepeater, { _key: Date.now(), tipoUbicacion, ubicacion, tpUbNombre, ubNombre }]);
        setSelSite(null); setSelArea(null); setSelLinea(null); setSelCelda(null);
        setAreasBySite([]); setLineasByArea([]); setCeldasByLinea([]);
    };

    const delUb = (event, idx) => {
        event.preventDefault();
        setUbRepeater(ubRepeater.filter((_, i) => i !== idx));
    };

    const displayAreas = areasBySite.length > 0 ? areasBySite : areas;

    return (
        <div className="ubicacion-section">
            <TransitionGroup>
                {ubRepeater.map((item, idx) => (
                    <CSSTransition key={item._key ?? idx} timeout={220} classNames="ub-item">
                        <div className="ubicacion-row">
                            <div className="ubicacion-row-fields">
                                <TextField label="Tipo" value={item.tpUbNombre} disabled fullWidth size="small" />
                                {item.tipoUbicacion !== 0 && item.ubNombre && (
                                    <TextField label="Ubicación" value={item.ubNombre} disabled fullWidth size="small" />
                                )}
                            </div>
                            <IconButton size="small" onClick={e => delUb(e, idx)}>
                                <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                        </div>
                    </CSSTransition>
                ))}
            </TransitionGroup>

            <div className="ubicacion-cascade">
                {/* Empresa — fija */}
                <div className="ubicacion-cascade-level">
                    <div className="ubicacion-cascade-field">
                        <InputLabel shrink>Empresa</InputLabel>
                        <Select value="empresa" disabled fullWidth>
                            <MenuItem value="empresa">{process.env.REACT_APP_COMPANY_NAME || 'Empresa'}</MenuItem>
                        </Select>
                    </div>
                </div>

                {/* Site */}
                <div className="ubicacion-cascade-level ubicacion-cascade-indent">
                    <div className="ubicacion-cascade-field">
                        <InputLabel shrink>Site</InputLabel>
                        <Select value={selSite?.codigo?.toString() ?? ''} onChange={handleSiteChange} fullWidth displayEmpty>
                            <MenuItem value="">Toda la empresa</MenuItem>
                            {sites.map(item => (
                                <MenuItem key={item.codigo.toString()} value={item.codigo.toString()}>
                                    {item.nombre}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>

                {/* Área — aparece al seleccionar Site */}
                {selSite && (
                    <div className="ubicacion-cascade-level ubicacion-cascade-indent">
                        <div className="ubicacion-cascade-field">
                            <InputLabel shrink>Área</InputLabel>
                            <Select value={selArea?.codigo?.toString() ?? ''} onChange={handleAreaChange} fullWidth displayEmpty>
                                <MenuItem value="">Todo el site</MenuItem>
                                {displayAreas.map(item => (
                                    <MenuItem key={item.codigo.toString()} value={item.codigo.toString()}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                )}

                {/* Línea — aparece al seleccionar Área */}
                {selArea && (
                    <div className="ubicacion-cascade-level ubicacion-cascade-indent">
                        <div className="ubicacion-cascade-field">
                            <InputLabel shrink>Línea</InputLabel>
                            <Select value={selLinea?.codigo?.toString() ?? ''} onChange={handleLineaChange} fullWidth displayEmpty>
                                <MenuItem value="">Toda el área</MenuItem>
                                {lineasByArea.map(item => (
                                    <MenuItem key={item.codigo.toString()} value={item.codigo.toString()}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                )}

                {/* Celda — aparece al seleccionar Línea */}
                {selLinea && (
                    <div className="ubicacion-cascade-level ubicacion-cascade-indent">
                        <div className="ubicacion-cascade-field">
                            <InputLabel shrink>Celda</InputLabel>
                            <Select value={selCelda?.codigo?.toString() ?? ''} onChange={handleCeldaChange} fullWidth displayEmpty>
                                <MenuItem value="">Toda la línea</MenuItem>
                                {celdasByLinea.map(item => (
                                    <MenuItem key={item.codigo.toString()} value={item.codigo.toString()}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                )}

                <div className="ubicacion-cascade-add">
                    <IconButton size="small" color="primary" onClick={newUb}>
                        <AddCircleOutlineIcon />
                    </IconButton>
                </div>
            </div>
        </div>
    );
}
